const getRatio = ({ width, height }) => parseFloat((width / height).toFixed(6));

export default getRatio;
